import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
function Student(){
    return (
        <div>
            <Navbar/>
            <h2>Login</h2>
            <Footer/>
        </div>
    )
}
export default Student;